var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "40",
    cy: "40",
    r: "40"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6 53.4a5.24 5.24 0 0 0 3.84 1.6h27.2c1.5 0 2.79-.54 3.85-1.6a5.24 5.24 0 0 0 1.6-3.84H20c0 1.5.53 2.78 1.6 3.84zM30.2 46.83h14.96c1.3 0 2.43-.46 3.36-1.4a4.58 4.58 0 0 0 1.4-3.36v-.68h1.37c2.25 0 4.17-.8 5.77-2.39a7.86 7.86 0 0 0 2.39-5.77c0-2.25-.8-4.17-2.4-5.77a7.86 7.86 0 0 0-5.76-2.39H26.8c-.37 0-.69.14-.96.4-.26.27-.4.6-.4.96v15.64c0 1.3.47 2.43 1.4 3.36.94.94 2.06 1.4 3.36 1.4zm19.73-17.68h1.36c1.13 0 2.1.4 2.89 1.2.79.79 1.19 1.75 1.19 2.88 0 1.14-.4 2.1-1.2 2.9-.79.79-1.75 1.18-2.88 1.18h-1.36v-8.16z"
  }))));
});